(function () {
    'use strict';

    angular
        .module('app')
        .factory('ddService', ddService);

    ddService.$inject = ['$http', '$q', '$timeout', 'systemOptionsService'];

    function ddService($http, $q, $timeout, systemOptionsService) {
        var service = {
            tableNumber: 1,
            currentRecord: {},
            loading: false,
            loadingTree: false,
            uniqueId: 0,
            unselectNodes: unselectNodes,
            getTree: getTree,
            whereUsed: getWhereUsed,
            children: getChildren,
            versions: getVersions,
            wipVersions: getWipVersions,
            workflow: getWorkflow,
            auditTrail: getAuditTrail,
            drawingInfo: getDrawingInfo,
            layout: getLayout,
            transmittal: getTransmittal,
            thumbnail: getThumbnail,
            mobilemarkups: getMobileMarkups,
            deleteOfflineFile: deleteOfflineFile,
            receiveOfflineFile: receiveOfflineFile,
            currentFocus: "main",
            data: [],
            close: close,
            refreshGrid: {},
            onResize: onResize,
            registerOnResizeCallBack: registerOnResizeCallBack,
            xRefReturnPacketModel: {},
        };
        var callBacks = [];

        service.opened = false;

        return service;

        function unselectNodes(tree) {
            if (!tree) {
                tree = service.tree;
            }
            angular.forEach(tree, function (item, key) {
                item.selected = false;
                if (angular.isArray(item.children)) {
                    unselectNodes(item.children);
                }
            });
        }

        function close() {
            service.currentRecord = {};
            service.data = [];
        }

        function getTree(node, bWorkAreaWindowActive) {

            var record; 

            if (!node.SCHEMA_S_FILEID)
                record = { SCHEMA_S_FILEID: node.childId, SCHEMA_S_MAJREV: node.childMajRev, SCHEMA_S_MINREV: node.childMinRev, SCHEMA_S_SRCDB: node.stateChild == 'R' ? 14 : 1 };
            else
                record = node;

            service.loadingTree = true;

            var deferred = $q.defer();

            var id = record.SCHEMA_S_FILEID;
            var maj = record.SCHEMA_S_MAJREV;
            var min = record.SCHEMA_S_MINREV;
            var fileName = record.SCHEMA_S_LONGNAME;
            //TD 06-13-2018 (25350) Use the tablenumber in the record object. We can have mixed displays where a file is in Revision.
            var tblNum = record.SCHEMA_S_SRCDB;
            //get the record data from the server
            var url = '../Synergis.WebApi/api/DocumentDashboard/GetTree/';
            $http.get(url.concat(tblNum + '/' + id + '/' + maj + '/' + min + '/' + bWorkAreaWindowActive + '?bDirectChildren=true')).then(function (response) {
                service.xRefReturnPacketModel = response.data;
                var data = response.data;
                var tree = [];
                //get the parent node
                var parent;

                if (node.childId) {
                    parent = node;
                    parent.childNodeList = data.xRefTopLevelNode.childNodeList;
                }
                    
                else {
                    parent = data.xRefTopLevelNode;
                    //set the name
                    parent.name = fileName;
                }
                               
                //reset the uniqueId
                service.uniqueId = 0;
                //expand the first node
                parent.expanded = true;

                parent.isLinked = response.data.fileItems[parent.childId].linked != 'U';
               

                //format the tree
                tree = buildTree(data.fileItems, [parent], tree);

                //TD 08-27-2021 (28707) do NOT look for file if node is unavailable or undefined (85 or 63)
                angular.forEach(tree, function (item, key) {
                    //set the parent object
                    angular.forEach(item.childNodeList, function (item, key) {
                        if (item.stateChild != 85 && item.stateChild != 63) {
                            item.isLinked = response.data.fileItems[item.childId].linked != 'U';
                            item.parentObject = parent;
                        }
                    });
                });
                
  
                //set the top node as the current record
                service.currentRecord = parent;

                var setIsParent = function (node) {
                    //set isParent
                    //TD 08-27-2021 (28707) do NOT look for file if node is unavailable or undefined (85 or 63)
                    if (node.stateChild != 85 && node.stateChild != 63) {
                        var fileItem = data.fileItems[node.childId];
                        node.isParent = fileItem ? fileItem.isParent : false;
                        if (node.childNodeList) {
                            if (node.childNodeList.length > 0) {
                                angular.forEach(node.childNodeList, function (item) {
                                    setIsParent(item);
                                });
                            }
                        }
                    }
                }

                angular.forEach(tree[0].childNodeList, function (node) {
                    node.isInfinite = checkForInfinite(node, node.parentObject);
                });
                
                setIsParent(parent);

                service.loadingTree = false;
                deferred.resolve(tree);
            }, function (response) {
                service.loadingTree = false;
                service.data = [];
                deferred.reject(response);
            });


            function buildTree(fileItems, data, tree) {
                //recursively build the tree

                angular.forEach(data, function (item, key) {

                    // If not set,
                    //if (item.icon == null || item.icon.length < 1) {
                    //    if (item.state == 77 || item.stateChild == 85) {
                    //        item.icon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AgGEDQyoFCkOAAAAn1JREFUOMuV1U9oXFUUx/HPu4lpwTSSlGqFDg2IYDsv/WeqZCF5g4uiLsSCxY0o1E1BUVARXLa4diUK0kV1X+1KbaEzcaElbeOfzoTSlcXUhBYHaVNwxsy7LmYK4/hS2gMP3nn33S+/8+eem+hZllWex3HcdHfLUcLxWq369uBi6HufxTvYgXS9p1ar7sAPeCbLKt8NAocH/LVarZo3SFCJvIEKNqMZqQY+fyvPYx7CC3gvyyonarXqa0UKwSKbI2cip3EI/6CBduDlyOn3Fy5Oj7Vap7ATr2RZ5cNC4LZbt0ZzfkYl4UJkupevvSjl7Md8aXV14ui5Hyf3Xr/+ET7AI/8DhhiTI5d+fRfb8FWZp6ZYSIkpeUqc4iJexcpwjFsOLzaOPdDpXNNN0X+BT68slx5qt1PMpxwsKm+DJ3CqV8B5zD539be0sMozy8u7IXJkHdi+yPmEgylX8CbsuXHj2ULgo7dvl9ohNPFTkbLIXMJsmcu6MV7AynirtbMQOJLnG9dCWE368tEH+zphf5mFO99j97/mUJ6PFfZhKwz9PZzno4E4EOZcD3a5f2NCjEx0QrhZqPCP0QevjuT5xBp71guz33ottbW5YWO9EPjN9slzSIb4pM7jkZODYQ7Yp7Dw8JazhcAr4+N//jUy8ktkBt9HXixSBnVO4kmc/Xb7ZLHCmCQ+m9r1MX7H1oQTl9hXJ2kQ6iR1puucx0tYwqFOCHG9aWNp06bV0M3hGcz0WuNa7B7HpV4zT/fWd6c07za+6J72ZuRApBz5Am08hjV8GSnjQBGsaHyBqW7rLOJ192mDwOEsqwQM3eP+ziCj35nrXQFH71PUGA7fcf4F8+fayalB+r4AAAAASUVORK5CYII=";
                    //    }
                    //    else {
                    //        item.icon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AcVFTYQgTEqFQAAAMxJREFUOMvt1TFKBDEUh/Gf69ZWthZaueAVxBfBRg9hob0WnsDCW2zhAfYAVnk23sELbK+1O9iMsoy7OoJgMx8E8gj58k8CyYaWiHKKKV59T4MdTDPrVXdwtNQ/wjUmOFjXMusETziMKA9tmE/JuLPAW2Zt2hQ/pTzDTUS5z6znEUVm/SLsS4MZXnAcUZ4z692qhH25xDYWOMHuui33IrPOMW/Pbx97qy7lTxiEg3AQ/ouw+ziMI8oImz3nL7qO5eKx/QJufxlqCxcfxTuVSC8kzG0hQAAAAABJRU5ErkJggg==";
                    //    }
                    //}
                    item.stateIcon = "";
                    item.docIcon = "";
                    item.docSelectedIcon = "";
                    if (item.stateIconKey != null && item.stateIconKey.length > 0) {
                        item.stateIcon = service.xRefReturnPacketModel.stateIcons[item.stateIconKey];
                    }
                    if (item.docIconKey != null && item.docIconKey.length > 0) {
                        item.docIcon = service.xRefReturnPacketModel.docIcons[item.docIconKey];
                    }
                    if (item.docSelectedIconKey != null && item.docSelectedIconKey.length > 0) {
                        item.docSelectedIcon = service.xRefReturnPacketModel.docSelectedIcons[item.docSelectedIconKey];
                    }

                    //console.info("node: ", item);
                    
                    //build the item's children
                    var children = buildTree(fileItems, item.childNodeList, []);
                    //set the children
                    item.children = children.length > 0 ? children : null;

                    // Get the correct longName, not what is referenced in the parent which can be from extraction
                    // TD 06-14-2019 (26981) We have to be careful checking for the right filename to be sure that
                    //                       this item is not a missing child, in which case childId and the actual 
                    //                       fileItems entry will be null.
                    if (item.childId != null && fileItems[item.childId] != null) {
                        var longName = fileItems[item.childId].longName;
                        if (longName != "") {
                            item.name = longName;
                        }
                    }

                    //add single item
                    service.uniqueId = service.uniqueId + 1;
                    item.uniqueId = service.uniqueId;
                    tree.push(item);
                })
                return tree;
            }

            

            return deferred.promise;

        }

        function checkForInfinite(node, parent) {
            if (parent) {
                if (parent.childId === node.childId) {
                    return true;
                }
                else {
                    return checkForInfinite(node, parent.parentObject);
                }
            }
            return false;
        }


        function containsObject(obj, list) {
            var i;
            for (i = 0; i < list.length; i++) {
                if (list[i] === obj) {
                    return true;
                }
            }

            return false;
        }

        //XRITEM_IN = 'I',            /*73*/
        //XRITEM_OUT = 'O',           /*79*/
        //XRITEM_OUT_OTHER = 'T',     /*84*/
        //XRITEM_HOLD = 'H',          /*72*/
        //XRITEM_NEW = 'N',           /*78*/
        //XRITEM_NEW_OTHER = 'E',     /*69*/
        //XRITEM_UNAVAILABLE = 'U',   /*85*/
        //XRITEM_REV = 'R',           /*82*/
        //XRITEM_INFINITE = 'F',      /*70*/
        //XRITEM_UNDEFINED = '?'      /*63*/
        //function relStateToTableNumber(stateChild) {
        //    if(stateChild == 82)
        //        return 14; // C_REVISION
        //    else if(stateChild == 73 
        //        || stateChild == 79
        //        || stateChild == 84
        //        || stateChild == 72
        //        || stateChild == 78
        //        || stateChild == 69)
        //        return 1; // C_FILES
        //    return 0; // C_INVALID
        //}

        function getWhereUsed(record, sort, skip, take, bWorkAreaWindowActive) {
            service.loading = true;
            var deferred = $q.defer();
            var tableNumber = 0; //record.childTableNumber; //relStateToTableNumber(record.stateChild);
            var id = record.childId;
            var maj = record.childMajRev;
            var min = record.childMinRev;
            if (id) {
                //get the record data from the server
                var url = '../Synergis.WebApi/api/DocumentDashboard/WhereUsed/';
                // TableNumber should come from the record not service.tableNumber
                $http.get(url.concat(tableNumber + '/' + id + '/' + maj + '/' + min + '/' + sort.sortField + '/' + sort.sortOrder + '/' + skip + '/' + take + "/" + bWorkAreaWindowActive)).then(function (response) {
                    service.data = response.data.AdeptDataTable ? response.data.AdeptDataTable.TableRecords : response.data;
                    service.menuEnables = response.data.MenuEnables;
                    deferred.resolve(response.data);
                    service.loading = false;
                }, function (response) {
                    service.loading = false;
                    deferred.reject(response);
                });
            }
            else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        function getChildren(record, sort, skip, take, bWorkAreaWindowActive) {
            service.loading = true;
            var deferred = $q.defer();
            var tableNumber = 0; //record.childTableNumber; //relStateToTableNumber(record.stateChild);
            var id = record.childId;
            var maj = record.childMajRev;
            var min = record.childMinRev;
            if (id) {
                //get the record data from the server
                var url = '../Synergis.WebApi/api/DocumentDashboard/children/';
                // TableNumber should come from the record not service.tableNumber
                $http.get(url.concat(tableNumber + '/' + id + '/' + maj + '/' + min + '/' + sort.sortField + '/' + sort.sortOrder + '/' + skip + '/' + take + "/" + bWorkAreaWindowActive)).then(function (response) {
                    service.data = response.data.AdeptDataTable ? response.data.AdeptDataTable.TableRecords : response.data;
                    service.menuEnables = response.data.MenuEnables;
                    deferred.resolve(response.data);
                    service.loading = false;
                }, function (response) {
                    service.loading = false;
                    deferred.reject(response);
                });
            }
            else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        function getVersions(record) {
            service.loading = true;

            var deferred = $q.defer();

            var id = record.childId;
            var skip = 0;
            var take = 10000;

            //get the record data from the server
            var url = '../Synergis.WebApi/api/DocumentDashboard/versions/';
            $http.get(url.concat(id + '/' + skip + '/' + take)).then(function (response) {
                service.data = response.data.AdeptDataTable ? response.data.AdeptDataTable.TableRecords : response.data;
                service.menuEnables = response.data.MenuEnables;
                deferred.resolve(response.data);
                service.loading = false;
            }, function (response) {
                service.data = [];
                service.loading = false;
                deferred.reject(response);
            });

            return deferred.promise;
        }

        function getWipVersions(record) {
            service.loading = true;
            var deferred = $q.defer();
            var id = record.childId;
            var skip = 0;
            var take = 10000;

            //get the record data from the server
            var url = '../Synergis.WebApi/api/DocumentDashboard/WipVersions/';
            $http.get(url.concat(id + '/' + skip + '/' + take)).then(function (response) {
                service.data = response.data.AdeptDataTable ? response.data.AdeptDataTable.TableRecords : response.data;
                service.menuEnables = response.data.MenuEnables;
                deferred.resolve(response.data);
                service.loading = false;
            }, function (response) {
                service.data = [];
                service.loading = false;
                deferred.reject(response);
            });

            return deferred.promise;
        }

        function getWorkflow(record) {
            service.loading = true;
            var deferred = $q.defer();
            var tableNumber = 0; //record.childTableNumber; //relStateToTableNumber(record.stateChild);
            var id = record.childId;
            var maj = record.childMajRev;
            var min = record.childMinRev;
            if (id) {
                //get the record data from the server
                var url = '../Synergis.WebApi/api/DocumentDashboard/Workflow/';
                // TableNumber should come from the record not service.tableNumber
                $http.get(url.concat(tableNumber + '/' + id + '/' + maj + '/' + min)).then(function (response) {
                    service.data = response.data;
                    deferred.resolve(response.data);
                    service.loading = false;
                }, function (response) {
                    service.loading = false;
                    deferred.reject(response);
                });
            }
            else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        function getAuditTrail(record) {
            service.loading = true;
            var deferred = $q.defer();
            var id = record.childId;

            //get the record data from the server
            var url = '../Synergis.WebApi/api/DocumentDashboard/AuditTrail/';
            $http.get(url.concat(id)).then(function (response) {
                service.data = response.data;
                deferred.resolve(response.data);
                service.loading = false;
            }, function (response) {
                service.data = [];
                service.loading = false;
                deferred.reject(response);
            });

            return deferred.promise;
        }

        function getLayout(record) {
            service.loading = true;
            var deferred = $q.defer();
            var tableNumber = 0; //record.childTableNumber; //relStateToTableNumber(record.stateChild);
            var id = record.childId;
            var maj = record.childMajRev;
            var min = record.childMinRev;
            if (id) {
                //get the record data from the server
                var url = '../Synergis.WebApi/api/DocumentDashboard/Extended/';
                // TableNumber should come from the record not service.tableNumber
                $http.get(url.concat(tableNumber + '/' + id + '/' + maj + '/' + min)).then(function (response) {
                    service.data = response.data;
                    deferred.resolve(response.data);
                    service.loading = false;
                }, function (response) {
                    service.loading = false;
                    deferred.reject(response);
                });
            }
            else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        function getDrawingInfo(record) {
            service.loading = true;
            var deferred = $q.defer();
            var tableNumber = 0; //record.childTableNumber; //relStateToTableNumber(record.stateChild);
            var id = record.childId;
            var maj = record.childMajRev;
            var min = record.childMinRev;
            if (id) {
                //get the record data from the server
                var url = '../Synergis.WebApi/api/DocumentDashboard/DrawingInfo/';
                // TableNumber should come from the record not service.tableNumber
                $http.get(url.concat(tableNumber + '/' + id + '/' + maj + '/' + min)).then(function (response) {
                    service.data = response.data;
                    deferred.resolve(response.data);
                    service.loading = false;
                }, function (response) {
                    service.loading = false;
                    deferred.reject(response);
                });
            }
            else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        function getTransmittal(record) {
            service.loading = true;
            var deferred = $q.defer();
            var tableNumber = 0; //record.childTableNumber; //relStateToTableNumber(record.stateChild);
            var id = record.childId;
            var maj = record.childMajRev;
            var min = record.childMinRev;
            if (id) {
                //get the record data from the server
                var url = '../Synergis.WebApi/api/DocumentDashboard/Transmittal/';
                // TableNumber should come from the record not service.tableNumber
                $http.get(url.concat(tableNumber + '/' + id + '/' + maj + '/' + min)).then(function (response) {
                    service.data = response.data;
                    deferred.resolve(response.data);
                    service.loading = false;
                }, function (response) {
                    service.loading = false;
                    deferred.reject(response);
                });
            }
            else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        function getThumbnail(record) {
            service.loading = true;
            var deferred = $q.defer();
            var tableNumber = 0; //record.childTableNumber; //relStateToTableNumber(record.stateChild);
            var id = record.childId;
            var maj = record.childMajRev;
            var min = record.childMinRev;
            var missing = 77; // ApiTypes.STATEREL.STATEREL_MISSING
            if (id && record.state != missing) {
                //get the record data from the server
                var url = '../Synergis.WebApi/api/DocumentDashboard/ThumbnailPng/';
                // TableNumber should come from the record not service.tableNumber
                $http.get(url.concat(tableNumber + '/' + id + '/' + maj + '/' + min + '/' + '600' + '/' + '600')).then(function (response) {
                    service.data = [1];
                    deferred.resolve(response.data);
                    service.loading = false;
                }, function (response) {
                    service.loading = false;
                    deferred.reject(response);
                });
            }
            else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        function getMobileMarkupEnabled() {
            var enabled = systemOptionsService.startUpOptions['MobileEnabled'] ? systemOptionsService.startUpOptions['MobileEnabled'] : false;
            return enabled;
        }

        function getMobileMarkups(record) {
            service.loading = true;
            var deferred = $q.defer();
            var tableNumber = 0; //record.childTableNumber; //relStateToTableNumber(record.stateChild);
            var id = record.childId;
            var maj = record.childMajRev;
            var min = record.childMinRev;
            if (id) {
                //get the record data from the server
                var url = '../Synergis.WebApi/api/DocumentDashboard/mobile-markups/';
                // TableNumber should come from the record not service.tableNumber
                $http.get(url.concat(tableNumber + '/' + id + '/' + maj + '/' + min)).then(function (response) {
                    service.data = response.data;
                    deferred.resolve(response.data);
                    service.loading = false;
                }, function (response) {
                    service.loading = false;
                    deferred.reject(response);
                });
            }
            else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        function onResize() {
            angular.forEach(callBacks, function (cb) {
                cb();
            });
        }

        function deleteOfflineFile(item) {
            service.loading = true;
            var deferred = $q.defer();
            item = JSON.stringify(item);
            var url = '../Synergis.WebApi/api/Offline/delete';
            $http.post(url, item, { headers: { "Content-Type": "application/json" } }).then(function (response) {
                service.data = response.data;
                deferred.resolve(response.data);
                service.loading = false;
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function receiveOfflineFile(item) {
            service.loading = true;
            var deferred = $q.defer();
            item = JSON.stringify(item);
            var url = '../Synergis.WebApi/api/Offline/receive';
            $http({url: url, method: "POST", responseType: "blob", data: item, headers: { "Content-Type": "application/json" } }).then(function (response) {
                var blob = new Blob([response.data], { type: "application/pdf" });
                var data = window.URL.createObjectURL(blob);
                window.open(data);
                deferred.resolve(response.data);
                service.loading = false;
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });

            return deferred.promise;
        }

        
        function registerOnResizeCallBack(callBack) {
            var duplicate = false;
            angular.forEach(callBacks, function (cb) {
                if (cb.toString() == callBack.toString()) {
                    duplicate = true;
                }
            })

            if (!duplicate) {
                callBacks.push(callBack);
            }            
        }





    }


})();